import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { DataService } from '../data.service';
import { KeretService } from '../keret.service';
import { FOKUSZ_KEPES, ModulTema, kijeloltTema, temaNev } from '../modul-tema';
import { modeFavicon, modeNev } from '../mode-nevek';
import { FelhasznaloBeallitasService } from '../felhasznalo-beallitas.service';
import { Szinmod, szinmod } from '../szinmod';

interface ModulSor { kod: string; nev: string; ikon: string; alap: ModulTema; alapNev: string; aktualis: boolean; }

/**
 *  BEÁLLÍTÁSOK – a felhasználó saját beállításai (2026-10-16).
 *
 *  A user: „a témaválasztót ne a menübe tegyük, mert túl sok helyet foglal … beállítások menü,
 *  felhasználói szintű, és akkor a felhasználó maga választhatja ki a preferált témát; az
 *  alapértelmezettet mi választjuk adminban továbbra is”.
 *   - Téma modulonként (csak a Fókusz-kerettel rendelkező modulokban): Intézményi alapértelmezés /
 *     Klasszikus / Fókusz. Az alapértelmezést az admin jelöli ki (Admin › Modulok témája).
 *   - A menü és a fejléc színe a SULINFORM Fókuszában (a tartalom mindig világos).
 *  Tárolás: backend/felhasznalo-beallitas.js (felhasználónként, minden eszközön ugyanaz).
 */
@Component({
  selector: 'app-felhasznalo-beallitasok',
  standalone: true,
  imports: [CommonModule, IonicModule],
  templateUrl: './beallitasok.component.html',
  styleUrls: ['./beallitasok.component.scss'],
})
export class FelhasznaloBeallitasokComponent implements OnInit {
  modulok: ModulSor[] = [];
  szinmodLathato = FOKUSZ_KEPES.has('SULINFORM');
  fut = false;

  constructor(private data: DataService, private keret: KeretService, public fb: FelhasznaloBeallitasService) {}

  async ngOnInit() {
    const sajat: any = await this.data.getFromStorage('sajatIntezmeny').catch(() => null);
    const aktualis = String((await this.data.getFromStorage('currentMode').catch(() => '')) || '');
    const modok = (this.keret.a?.modok() || []).map((m) => m.name);
    const kodok = [...new Set([aktualis, ...modok])].filter((k) => k && FOKUSZ_KEPES.has(k));
    this.modulok = kodok.map((kod) => {
      const alap = kijeloltTema(kod, sajat?.mode_tema);
      return { kod, nev: modeNev(kod), ikon: modeFavicon(kod), alap, alapNev: temaNev(alap), aktualis: kod === aktualis };
    });
  }

  valasztott(kod: string): ModulTema | null { return this.fb.tema(kod); }
  get szinmod(): Szinmod { return this.fb.adat.szinmod || szinmod(); }

  async temaValaszt(kod: string, tema: ModulTema | null) {
    if (this.fut || this.valasztott(kod) === tema) return;
    this.fut = true;
    try {
      await this.fb.ment({ tema: { [kod]: tema } });
      this.data.sendToast(tema ? `${modeNev(kod)}: ${temaNev(tema)} téma.` : `${modeNev(kod)}: az intézményi alapértelmezés.`, 'success');
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'A beállítás nem menthető.', 'error');
    } finally { this.fut = false; }
  }

  async szinmodValaszt(m: Szinmod) {
    if (this.fut) return;
    this.fut = true;
    try { await this.fb.ment({ szinmod: m === 'rendszer' ? null : m }); }
    catch (e: any) { this.data.sendToast(e?.error?.error || 'A beállítás nem menthető.', 'error'); }
    finally { this.fut = false; }
  }
}
